import * as CubiqTS from "shared/cubiq-model-multi-asset";

export enum ClientAccountVisibilityType {
  None = 0,
  Privatized,
  Visible,
  Full,
}

export namespace ClientAccountVisibilityType {
  export function setVisibilityType(model: any, type: ClientAccountVisibilityType): object {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      model.extendedInfo.set("__bfx_visibility_type", ClientAccountVisibilityType[type]);
    } else if (model !== null && typeof model === "object") {
      model["__bfx_visibility_type"] = type;
    }

    return model;
  }

  export function hasVisibilityType(model: object | CubiqTS.ConcreteEncodable) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_visibility_type")) {
        let type = ClientAccountVisibilityType[model.extendedInfo.get("__bfx_visibility_type")];
        return type > ClientAccountVisibilityType.None;
      }
      return false;
    }

    if (model == null || typeof model != "object") return false;

    return (
      Object.prototype.hasOwnProperty.call(model, "__bfx_visibility_type") &&
      model["__bfx_visibility_type"] > ClientAccountVisibilityType.None
    );
  }

  export function getVisibilityType(model: object | CubiqTS.ConcreteEncodable) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_visibility_type")) {
        let type = ClientAccountVisibilityType[model.extendedInfo.get("__bfx_visibility_type")];
        return type;
      }
      return ClientAccountVisibilityType.None;
    }

    if (model == null || typeof model != "object") return ClientAccountVisibilityType.None;

    if (Object.prototype.hasOwnProperty.call(model, "__bfx_visibility_type"))
      return model["__bfx_visibility_type"];
  }

  export function isFull(model: object | CubiqTS.ConcreteEncodable) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_visibility_type")) {
        let type = ClientAccountVisibilityType[model.extendedInfo.get("__bfx_visibility_type")];
        return type == ClientAccountVisibilityType.Full;
      }
      return false;
    }

    if (model == null || typeof model != "object") return false;

    return (
      Object.prototype.hasOwnProperty.call(model, "__bfx_visibility_type") &&
      model["__bfx_visibility_type"] == ClientAccountVisibilityType.Full
    );
  }

  export function isPrivatized(model: object | CubiqTS.ConcreteEncodable) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_visibility_type")) {
        let type = ClientAccountVisibilityType[model.extendedInfo.get("__bfx_visibility_type")];
        return type == ClientAccountVisibilityType.Privatized;
      }
      return false;
    }

    if (model == null || typeof model != "object") return false;

    return (
      Object.prototype.hasOwnProperty.call(model, "__bfx_visibility_type") &&
      model["__bfx_visibility_type"] == ClientAccountVisibilityType.Privatized
    );
  }

  export function isVisible(model: object | CubiqTS.ConcreteEncodable) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_visibility_type")) {
        let type = ClientAccountVisibilityType[model.extendedInfo.get("__bfx_visibility_type")];
        return type == ClientAccountVisibilityType.Visible;
      }
      return false;
    }

    if (model == null || typeof model != "object") return false;

    return (
      Object.prototype.hasOwnProperty.call(model, "__bfx_visibility_type") &&
      model["__bfx_visibility_type"] == ClientAccountVisibilityType.Visible
    );
  }

  /**
   *
   * @param model Visible or Full
   */
  export function canSee(model: object | CubiqTS.ConcreteEncodable) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_visibility_type")) {
        let type = ClientAccountVisibilityType[model.extendedInfo.get("__bfx_visibility_type")];
        return (
          type == ClientAccountVisibilityType.Visible || type == ClientAccountVisibilityType.Full
        );
      }
      return false;
    }

    if (model == null || typeof model != "object") return false;

    return (
      Object.prototype.hasOwnProperty.call(model, "__bfx_visibility_type") &&
      (model["__bfx_visibility_type"] == ClientAccountVisibilityType.Visible ||
        model["__bfx_visibility_type"] == ClientAccountVisibilityType.Full)
    );
  }

  export function cantSee(model: object | CubiqTS.ConcreteEncodable) {
    return !canSee(model);
  }
}
